/*--公共方法封装插件--*/
//日期格式化
export function formatDate(date) {
  if (!date) return null
  const [year, month, day] = date.split('-')
  return `${month}/${day}/${year}`
}
//日期格式化
export function parseDate(date) {
  if (!date) return null
  const [month, day, year] = date.split('/')
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
}
//日期格式化
export function parseDate_M(date) {
  if (!date) return null
  const [year, month, day] = date.split(' ')[0].split('-')
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
}
//数字格式化
export function format(num) {
  if (!num) return 0
  num = Unformat(num)
  var reg = /\d{1,3}(?=(\d{3})+(\.\d*)?$)/g
  return (num + '').replace(reg, '$&,')
}
//数据反格式化
export function Unformat(num) {
  if (!num) return 0
  return parseFloat((num + '').replace(/,/g, '')).toFixed(2)
}
export function PowerJudge(role) {
  let result = false
  let logininfo = JSON.parse(localStorage.getItem('loginuser'))
  if (logininfo != undefined && logininfo != null) {
    let roles = logininfo.Roles
    let item = roles.filter(x => {
      return x == role
    })
    if (item != null && item.length > 0) {
      result = true
    }
  }
  return result
}
export function PowerSeeting(roles) {
  let items = []
  //判断master-view
  let masterview = roles.filter(x => {
    return x == 'master-view'
  })
  if (masterview.length == 0) {
    let mastermodify = roles.filter(x => {
      return x == 'master-modify'
    })
    let masterconfirm = roles.filter(x => {
      return x == 'master-confirm'
    })
    if (
      (mastermodify != null && mastermodify.length > 0) ||
      (masterconfirm != null && masterconfirm.length > 0)
    ) {
      roles.push('master-view')
    }
  }
  let configview = roles.filter(x => {
    return x == 'config-view'
  })
  if (configview.length == 0) {
    let configmodify = roles.filter(x => {
      return x == 'config-modify'
    })
    if (configmodify != null && configmodify.length > 0) {
      roles.push('config-view')
    }
  }
  items = roles
  return items
}
